/* tslint:disable */
/* eslint-disable */
/**
 * gremiumhub
 * A platform for digital applications, approvals and discussions.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: denis.lugowski@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SigniusVerificationCallbackDto
 */
export interface SigniusVerificationCallbackDto {
    /**
     * Verification result (e.g. SUCCESS)
     * @type {string}
     * @memberof SigniusVerificationCallbackDto
     */
    status: string;
    /**
     * The user's email address
     * @type {string}
     * @memberof SigniusVerificationCallbackDto
     */
    identifier: string;
}

/**
 * Check if a given object implements the SigniusVerificationCallbackDto interface.
 */
export function instanceOfSigniusVerificationCallbackDto(value: object): value is SigniusVerificationCallbackDto {
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('identifier' in value) || value['identifier'] === undefined) return false;
    return true;
}

export function SigniusVerificationCallbackDtoFromJSON(json: any): SigniusVerificationCallbackDto {
    return SigniusVerificationCallbackDtoFromJSONTyped(json, false);
}

export function SigniusVerificationCallbackDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SigniusVerificationCallbackDto {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'],
        'identifier': json['identifier'],
    };
}

export function SigniusVerificationCallbackDtoToJSON(json: any): SigniusVerificationCallbackDto {
    return SigniusVerificationCallbackDtoToJSONTyped(json, false);
}

export function SigniusVerificationCallbackDtoToJSONTyped(value?: SigniusVerificationCallbackDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': value['status'],
        'identifier': value['identifier'],
    };
}

